import React from 'react';
import DeleteObject from '../../../common/poppers/DeleteObject';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ActivateObject from '../../../common/poppers/ActivateObject';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import ModifyCarDay from './ModifyCarDay';
import ModifyCarDayLocation from './ModifyCarDayLocation';


export const carDayLocationActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Helyszín módosítása",
        dialogTitle: "Helyszín módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        canShow: (row) => row,
        actionComponent: (props, close) => <ModifyCarDayLocation {...props} close={close} />
    },
    {
        dataDialog: "delete-dialog",
        title: "Helyszín törlése",
        dialogTitle: "Helyszín törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/cardaylocation'} confirm={"Biztos hogy törölni szeretnéd a helyszínt?"} comp={<div>{props.row.licenseNumber} {props.row.date} </div>} />
    },
]